export default __webpack_public_path__ + "static/media/IMG_4214_Original.98cf9e32.jpg";